/*
 * @Author: maosheng
 * @Date: 2021-10-24 07:34:52
 * @LastEditTime: 2021-11-03 16:35:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \prisme:\tutu\tutu-admin\src\api\payment\payment.ts
 */
import request from '@/utils/request'
import qs from 'qs'

interface pageInfo {
  page: number
  pageCount: number
}

// ********************************数据看板******************************/
// 最近两天的统计数据列表接口
export const getLast2DaysData = (params: { statType: string }) =>
  request({
    url: '/payment/orderStat/getLastTwoDaysStatData',
    method: 'get',
    params
  })

interface dateRange {
  statDateStart: string,
  statDateEnd: string
}
// 通道数量统计列表
export const getCountDataList = (params: dateRange) =>
  request({
    url: '/payment/orderStat/getCountDataList',
    method: 'get',
    params
  })

interface amountDateRange extends dateRange {
  statType: string
}
// 金额统计列表
export const getAmountDataList = (params: amountDateRange) =>
  request({
    url: '/payment/orderStat/getAmountDataList',
    method: 'get',
    params
  })

// 支付通道统计列表
export const getPayGatePayAmountDataList = (params: dateRange) =>
  request({
    url: '/payment/orderStat/getPayGatePayAmountDataList',
    method: 'get',
    params
  })

// ********************************流水查询******************************/
// 支付订单列表
interface orderParams extends pageInfo {
  'transaction_no': string,
  'app_key': string,
  'app_order_sns': string,
  'pay_gate_code': string,
  'pay_status': string,
  'pay_config': string,
  'ext_order_sn': string,
  createDateStart: string,
  createDateEnd: string
}
export const getPaidOrderList = (params: orderParams) =>
  request({
    url: '/payment/payOrderTransaction/getListDataJson',
    method: 'get',
    params
  })

// ********************************接入模块******************************/
// 接入模块列表
export const accessList = (params: pageInfo) =>
  request({
    url: '/payment/payApp/getListDataJson',
    method: 'get',
    params
  })

// 获取接入模块信息
export const getAccessInfo = (params: { id: number }) =>
  request({
    url: '/payment/payApp/getDataJson',
    method: 'get',
    params
  })

interface moduleInfo {
  id: number
  name: string
  description?: string
}
// 保存接入模块信息
export const saveModuleInfo = (data: moduleInfo) =>
  request({
    url: '/payment/payApp/saveDataJson',
    method: 'post',
    data: qs.stringify(data)
  })

// ********************************支付账号******************************/
// 支付网关列表接口
export function getPaymentList(params: pageInfo) {
  return request({
    url: '/payment/payGate/getListDataJson',
    method: 'get',
    params
  })
}

// 获取支付网关信息接口
export function getPaymentInfo(params: { id: number }) {
  return request({
    url: '/payment/payGate/getDataJson',
    method: 'get',
    params
  })
}

interface paymentForm {
  id: number
  name: string
  description: string
  code: string
  logo: string
  currency: string
  open: number
  'is_mobile_pay': number
  'is_html5': number
  seq: number
}
// 保存支付网关信息接口
export const savePaymentInfo = (data: paymentForm) =>
  request({
    url: '/payment/payGate/saveDataJson',
    method: 'post',
    data: qs.stringify(data)
  })

// 支付账号列表接口
export function getPaymentAccount(params: { 'pay_gate_id': number }) {
  return request({
    url: '/payment/merchantAccount/getListDataJson',
    method: 'get',
    params
  })
}

// 获取支付网关信息接口
export function getAccountInfo(params: { id: number }) {
  return request({
    url: '/payment/merchantAccount/getDataJson',
    method: 'get',
    params
  })
}

interface accountInfo {
  id: string
  'pa_gate_id': number
  'account_name': string
  'live_mode': number
  'app_id'?: string
  'merchant_id'?: string
  'merchant_account'?: string
  'app_key'?: string
  'app_secret'?: string
  'app_private_key'?: string
  'app_public_key'?: string
  'public_key'?: string
  'root_cert'?: string
}
// 保存支付账号信息
export const saveAccountInfo = (data: accountInfo) =>
  request({
    url: '/payment/merchantAccount/saveDataJson',
    method: 'post',
    data: qs.stringify(data)
  })

// 使用当前账号
export const useAccount = (data: { id: number }) =>
  request({
    url: '/payment/merchantAccount/useAccount',
    method: 'post',
    data: qs.stringify(data)
  })

// ********************************通道配置******************************/

// 通道配置列表
export const getChannelList = () =>
  request({
    url: '/payment/dynamicConfig/getListDataJson',
    method: 'get'
  })

interface configParams {
  id: number
  'item_value': number | string
}
// 保存配置项的值
export const saveConfig = (data: configParams) =>
  request({
    url: '/payment/dynamicConfig/updateItemValue',
    method: 'post',
    data: qs.stringify(data)
  })

// 检查订单状态接口
export const checkOrderStatus = (data: { id: string }) =>
  request({
    url: '/payment/payOrderTransaction/checkOrderStatus',
    method: 'post',
    data: qs.stringify(data)
  })

// 删除支付账号信息接口
export const deleteMerchantAccount = (data: { id: number }) =>
  request({
    url: '/payment/merchantAccount/deleteJson',
    method: 'post',
    data: qs.stringify(data)
  })

// 删除接入模块信息
export const deletePayApp = (data: { id: number }) =>
  request({
    url: '/payment/payApp/deleteJson',
    method: 'post',
    data: qs.stringify(data)
  })

// 开启/关闭支付通道
export const payAppSwitch = (data: { id: number }) =>
  request({
    url: '/payment/payGate/openSwitch',
    method: 'post',
    data: qs.stringify(data)
  })
